import type { Client } from '~/models'

export function getClientFind(
  client: Pick<Client, 'find' | 'filter_by_geography' | 'geom'>,
  filtersFind: Record<string, any>
) {
  const find = {
    ...(client.find || {}),
    ...filtersFind,
    ...(client.find?.$and
      ? { $and: [...client.find.$and, ...(filtersFind.$and || [])] }
      : {}),
  }

  return client.filter_by_geography
    ? withLocationFilters(find, null, {
        $geoWithin: { $geometry: client.geom },
      })
    : find
}

export function withLocationFilters(
  find: Record<string, any>,
  selectedLayerLocation: Record<string, any> | null,
  mapLocation: Record<string, any>
) {
  const { location, $and, ...rest } = find
  const locationFilters = [
    ...(location ? [{ location }] : []),
    ...(selectedLayerLocation ? [{ location: selectedLayerLocation }] : []),
    { location: mapLocation },
  ]
  const andFilters = [...($and || []), ...locationFilters]

  if (andFilters.length === 1) {
    return { ...rest, ...andFilters[0] }
  }

  return { ...rest, $and: andFilters }
}
